import * as damConnectionStatusTypes from '../../consts/dam/damConnectionStatusTypes';
import releaseNotesTypes from '../../consts/fwu/releaseNotesTypes';
import deviceHelpers from '../device/deviceHelpers';

const authTokenMapping = (response) => response?.authToken;

const userDevicesMapping = (response) =>
    response?.data?.registered_devices?.map((device) => ({
        dusn: device?.dusn,
        assetId: device?.asset_id,
        codentify: device?.codentify,
    }));

const deviceSynchronisationMapping = (response) => response?.requestId;

const initialDeviceDataMapping = (deviceData) => {
    const {dusn: serialNumber, assetId, codentify, connectionType} = deviceData || {};
    const type = deviceHelpers.getDeviceTypeBySerialNumber(serialNumber);
    const deviceTypeData = deviceHelpers.getDeviceDataByType(type);

    return {
        assetId,
        serialNumber,
        connectionStatus: damConnectionStatusTypes.DISCONNECTED,
        codentify,
        connectionType,
        type,
        ...deviceTypeData,
    };
};

const firmwareAvailabilityMapping = (response) => ({
    availableFirmwareVersion: response?.availableFirmware,
    releaseNotes: releaseNotesMapping(response?.releaseNotes),
});

const firmwareUpdateMapping = (response) => response?.requestId;

const releaseNotesMapping = (response) => {
    if (!response?.length) return;

    const mappedData = response?.map((releaseNote) => {
        const {version, releaseNotesType, localizations, mediaData, thumbnails} = releaseNote || {};
        let localizationsData;

        switch (releaseNotesType) {
            case releaseNotesTypes.WALKTHROUGH:
            case releaseNotesTypes.LIST_WITH_ICONS:
                localizationsData = localizations?.map((localization) => ({
                    languageCode: localization?.language,
                    summary: localization?.summary,
                    features: localization?.features?.map((feature) => {
                        const featureMediaData = mediaData?.find((x) => x?.id === feature?.id);
                        const featureThumbnailData = thumbnails?.find((x) => x?.id === feature?.id);

                        return {
                            title: feature?.title,
                            description: feature?.description,
                            mediaSrc: featureMediaData?.media,
                            mediaExtension: featureMediaData?.mediaExtension,
                            thumbnailSrc: featureThumbnailData?.media,
                            linkText: feature?.linkText,
                            link: feature?.link,
                        };
                    }),
                }));
                break;
            case releaseNotesTypes.SIMPLE_LIST:
                localizationsData = localizations?.map((localization) => ({
                    languageCode: localization?.language,
                    summary: localization?.summary,
                    features: localization?.features,
                    improvements: localization?.improvements,
                }));
                break;
            default:
                break;
        }

        return {
            version,
            type: releaseNotesType,
            localizations: localizationsData,
        };
    });

    return mappedData?.sort((x, y) => x.version.localeCompare(y.version, undefined, {numeric: true}));
};

export default {
    authTokenMapping,
    userDevicesMapping,
    deviceSynchronisationMapping,
    initialDeviceDataMapping,
    firmwareAvailabilityMapping,
    firmwareUpdateMapping,
    releaseNotesMapping,
};
